import { z } from 'zod';
import { IObject } from '../../schemas/IObject';
import { EmailBaseSchema } from './EmailBaseSchema';

export const PauboxEmailSchema = EmailBaseSchema.extend({
  sourceTrackingId: z.string().min(1),
});

export type PauboxEmailData = z.infer<typeof PauboxEmailSchema>;
export type PauboxEmail = IObject.HasIdTimestamped<PauboxEmailData>;
